import { useMutation } from '@tanstack/react-query';
import { patchAllNotifications, patchNotification } from '@/api/notifications';

export function useMarkNotification() {
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) =>
      patchNotification(id, status),
  });
}

export function useMarkAllRead() {
  return useMutation({
    mutationFn: () => patchAllNotifications('READ'),
  });
}
